import { Alert } from '@heroui/react';
import classNames from 'classnames';
import type { TFuncKey } from 'i18next';

import DynamicT from '@/shared/components/DynamicT';

type Props = {
  readonly className?: string;
  readonly message: TFuncKey;
};

const InlineNotification = ({ className, message }: Props) => {
  return (
    <Alert role="alert" status="warning" className={classNames('w-full', className)}>
      <Alert.Indicator />
      <Alert.Content>
        <Alert.Description>
          <DynamicT forKey={message} />
        </Alert.Description>
      </Alert.Content>
    </Alert>
  );
};

export default InlineNotification;
